/*
  COTANTIN ニュース・ジャーナル共通。
  - 記事（cotantin-news-article / cotantin-journal-article）：SHARE の「URL」でページの URL をコピーする。
    コピーできたら数秒だけ文字を「コピーしました」（セクション設定）に替える。
  - 一覧（cotantin-news-list / cotantin-journal-list）：スマホではタブが横スクロールなので、
    選んでいるタブ（.is-current）が見えていなければ、タブの列を横に動かして中央に寄せる。
    ページ全体は動かさない（scrollIntoView は縦にも動くので使わない）。PC はタブが折り返して全部見えるので何もしない。
  - 記事：見出しを語の切れ目で折る。CSS の word-break: auto-phrase（assets/cotantin-blog.css）が効かないブラウザ（Safari など）だけ、
    assets/cotantin-phrase.js（BudouX）を読む。読み先は記事のセクションが <script> に付けた data-phrase（一覧には付けていない）。2026-10-26 Ignite ご意見 #56
*/
(function () {
  var me = document.currentScript;
  var phrase = me && me.getAttribute('data-phrase');
  if (phrase && !(window.CSS && CSS.supports && CSS.supports('word-break', 'auto-phrase'))) {
    var script = document.createElement('script');
    script.src = phrase;
    script.async = true;
    document.head.appendChild(script);
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(t);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cn-copy]');
    if (!button) return;
    var label = button.textContent;
    copy(button.getAttribute('data-cn-copy')).then(function () {
      button.textContent = button.getAttribute('data-cn-copied') || label;
      setTimeout(function () { button.textContent = label; }, 2000);
    }, function () { /* コピーできない環境では何もしない */ });
  });

  function revealCurrentTab() {
    var lists = document.querySelectorAll('.cn-tabs__list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var current = list.querySelector('.cn-tab.is-current');
      if (!current || list.scrollWidth <= list.clientWidth) continue;
      var box = list.getBoundingClientRect();
      var tab = current.getBoundingClientRect();
      var fade = 40; /* 右端のフェード（assets/cotantin-news.css の .cn-tabs::after） */
      if (tab.left >= box.left && tab.right <= box.right - fade) continue;
      list.scrollLeft += (tab.left - box.left) - (list.clientWidth - tab.width) / 2;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealCurrentTab);
  } else {
    revealCurrentTab();
  }
})();
